<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>Proyeksi Gaji </strong>
          </p>
        </template>
        <CRow>
          <CCol col="5">
            <b-form-group label="Periode" label-for="periode" class="my-0">
              <Multiselect
                id="periode"
                v-model="filter.periode"
                :options="listPeriodeGaji"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="-- Pilih Periode --"
                label="namaPeriode"
                track-by="id"
                @input="hitungTanggal()"
              ></Multiselect>
            </b-form-group>
          </CCol>
          <CCol col="4">
            <b-form-group label="Bulan - tahun" label-for="bulanTahun" class="my-0">
              <date-picker id="bulanTahun" type="month" format="MMMM - YYYY" style="width: 100%" v-model="filter.bulanTahun" @input="hitungTanggal()"></date-picker>
            </b-form-group>
          </CCol>
          <!-- <CCol col="4">
            <b-form-group label="Cabang" label-for="cabang" class="my-0">
              <Multiselect
                id="cabang"
                v-model="filter.cabang"
                :options="listCabang"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="-- Pilih Cabang --"
                label="namaCabang"
                track-by="cabangId"
              ></Multiselect>
            </b-form-group>
          </CCol> -->
          <CCol col="1" style="margin-bottom: 7px">
            <div class="w-100 h-100 d-flex align-items-end">
              <b-button variant="success" style="" class="d-block w-100" v-c-tooltip.hover.click="'Filter'" @click="hitungTanggal()">Filter</b-button>
            </div>
          </CCol>
          <CCol col="1" style="margin-bottom: 7px">
            <div class="w-100 h-100 d-flex align-items-end">
              <b-button variant="danger" style="" class="d-block w-100" v-c-tooltip.hover.click="'Reset'" @click="reset()">Reset</b-button>
            </div>
          </CCol>
          <CCol col="1" style="margin-bottom: 7px">
            <div class="w-100 h-100 d-flex align-items-end">
              <b-button variant="primary" style="" class="d-block w-100" v-c-tooltip.hover.click="'Download'" @click="downloadForm()">Download</b-button>
            </div>
          </CCol>

          <CCol col="12" class="">
            <small class="mx-2">{{ $moment(filter.tglAwal).format("LL") }} - {{ $moment(filter.tglAkhir).format("LL") }} ( {{ filter.jmlHari }} hari)</small>
          </CCol>
          <CCol col="12" class="mt-1 mb-2"><hr /></CCol>
          <CCol col="12">
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)"> </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
  </CRow>
</template>
<script>
export default {
  components: {},
  name: "laporanLembur",
  data() {
    return {
      data: {},
      listCabang: [],
      listPeriodeGaji: [],
      items: [],
      filter: {
        bulanTahun: null,
        tglAwal: null,
        tglAkhir: null,
        jmlHari: null,
        periode: null,
        cabang: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      return [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          _classes: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.karyawan,
          sortDirection: "desc",
          _style: "width: 30%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaGaji",
          label: this.$store.state.table.gaji,
          sortDirection: "desc",
          _style: "width: 10%;",
          _classes: "text-right",
          sorter: false,
          filter: false,
        },
        {
          key: "namaTotalTunjangan",
          label: this.$store.state.table.tunjangan,
          sortDirection: "desc",
          _style: "width: 7%;",
          _classes: "text-right",
          sorter: false,
          filter: false,
        },
        {
          key: "namaTotalInsentif",
          label: this.$store.state.table.insentif,
          sortDirection: "desc",
          _style: "width: 7%;",
          _classes: "text-right",
          sorter: false,
          filter: false,
        },
        {
          key: "namaTotalLembur",
          label: this.$store.state.table.lembur,
          sortDirection: "desc",
          _style: "width: 7%;",
          _classes: "text-right",
          sorter: false,
          filter: false,
        },
        {
          key: "namaTotalKomisi",
          label: this.$store.state.table.komisi,
          sortDirection: "desc",
          _style: "width: 7%;",
          _classes: "text-right",
          sorter: false,
          filter: false,
        },
        {
          key: "namaTotalPotongan",
          label: this.$store.state.table.potongan,
          sortDirection: "desc",
          _style: "width: 7%;",
          _classes: "text-right",
          sorter: false,
          filter: false,
        },
        {
          key: "namaTotalAsuransi",
          label: this.$store.state.table.asuransi,
          sortDirection: "desc",
          _style: "width: 7%;",
          _classes: "text-right",
          sorter: false,
          filter: false,
        },
        {
          key: "namaTotalDenda",
          label: this.$store.state.table.denda,
          sortDirection: "desc",
          _style: "width: 7%;",
          _classes: "text-right",
          sorter: false,
          filter: false,
        },
        {
          key: "namaTakeHomePay",
          label: this.$store.state.table.thp,
          sortDirection: "desc",
          _style: "width: 7%;",
          _classes: "text-right",
          sorter: false,
          filter: false,
        },
      ];
    },
  },
  async mounted() {
    // if (this.$store.state.role_aktif.kodeRole == "super") {
    //   this.fields.splice(1, 0, {
    //     key: "namaMitra",
    //     label: "Mitra",
    //     _style: "width: 7%;",
    //     sortDirection: "desc",
    //     class: "text-left",
    //     sorter: false,
    //   });
    // }
    // this.getDatas();
    // this.getCabang();
    await this.getPeriodeGaji();
    this.reset();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      vm.getDatas();
    },

    async downloadForm() {
      let bulan = this.$moment(this.filter.bulanTahun).format("MM");
      let tahun = this.$moment(this.filter.bulanTahun).format("YYYY");
      try {
        const res = await this.$axios.get(`downloadExcel/all?bulan=${bulan}&tahun=${tahun}`, {
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Data Gaji Karyawan ${this.$moment(this.filter.bulanTahun).format("MMMM YYYY")}.xlsx`;
        a.click();
      } catch (e) {
        console.error(e);
      }
    },
    async hitungTanggal() {
      const vm = this;
      if (!vm.filter.periode) vm.filter.periode = vm.listPeriodeGaji[0];
      const periode = vm.filter.periode;
      const monthYear = vm.$moment(vm.filter.bulanTahun).format("MM-YYYY");
      //set tanggal terakhir bulan
      const tanggalTerakhirBulan = vm.$moment(`${monthYear}`, "MM-YYYY").endOf("month").format("D");
      periode.xtanggalGajian = periode.tanggalGajian == -1 ? tanggalTerakhirBulan : periode.tanggalGajian;
      periode.xtanggalAwal = periode.tanggalAwal == -1 ? tanggalTerakhirBulan : periode.tanggalAwal;
      periode.xtanggalAkhir = periode.tanggalAkhir == -1 ? tanggalTerakhirBulan : periode.tanggalAkhir;
      //set tanggal default
      vm.filter.tglAwal = vm.$moment(`${periode.xtanggalAwal}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      vm.filter.tglAkhir = vm.$moment(`${periode.xtanggalAkhir}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      //jika tanggal awal adalah bulan sebelumnya (awal - akhir = 30 - 10)
      if (periode.xtanggalAwal > periode.xtanggalAkhir) {
        let tanggal = vm.$moment(`${monthYear}`, "MM-YYYY").subtract(1, "month");
        //jika xtanggalAwal adalah tanggal terakhir bulan
        let awal = periode.xtanggalAwal;
        /*
          jika tanggal awal = -1 (tanggal terakhir bulan) atau
          jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal akhir dalam bulan)
        */
        if (periode.tanggalAwal == -1 || periode.xtanggalAwal > vm.$moment(tanggal).endOf("month").format("D")) {
          awal = vm.$moment(tanggal).endOf("month").format("D");
        }
        vm.filter.tglAwal = vm.$moment(`${awal}-${tanggal.format("MM")}-${tanggal.format("YYYY")}`, "D-MM-YYYY").format("YYYY-MM-DD");
      } else {
        //jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal awal dalam bulan)
        if (periode.xtanggalAwal > tanggalTerakhirBulan) {
          vm.filter.tglAwal = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
        }
      }
      //jika tanggal akhir melebihi tanggal dalam bulan (bulan februari tetapi tanggal akhir = 30, maka tanggal akhir ikut 28 / tanggal akhir dalam bulan)
      if (periode.xtanggalAkhir > tanggalTerakhirBulan) {
        vm.filter.tglAkhir = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      }
      vm.filter.jmlHari = vm.$moment(vm.filter.tglAkhir).diff(vm.$moment(vm.filter.tglAwal), "Days") + 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      // let listLaporanGaji = await vm.$axios.post(vm.filter.periode.isBpjs ? 'dataKaryawan/rekapTanggalPerHalaman', {
      let listLaporanGaji = await vm.$axios.post(vm.filter.periode.isBpjs ? "dataKaryawan/rekapTanggalPerHalamanBpjs" : "dataKaryawan/rekapTanggalPerHalamanNonBpjs", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listLaporanGaji", listLaporanGaji);
      vm.items =
        listLaporanGaji.data.status == 200
          ? listLaporanGaji.data.data.map((x, idx) => {
              let absens = x.absensi[0];

              // RESET DATA
              x.totalNominalLembur = 0;
              x.totalLembur = 0;
              x.list_asuransi = [];
              x.list_denda = [];
              x.list_potongan = [];
              x.list_insentif = [];
              x.totalInsentif = 0;
              x.totalTunjangan = 0;
              x.totalPotongan = 0;
              x.totalAsuransi = 0;
              x.totalDenda = 0;

              // === LEMBUR ===
              if (x.lembur) {
                x.lembur.forEach((ele) => {
                  x.totalNominalLembur += Number(ele.nominalLembur);
                  x.totalLembur += Number(ele.jumlahJamLembur);
                });
              }

              // === ABSENSI / DENDA / POTONGAN ===
              if (absens) {
                // Clock In/Out selalu dihitung
                x.list_denda.push({
                  namaDenda: "Clock In/ Out",
                  jumlah: absens.hanyaAbsenKeluar + absens.hanyaAbsenMasuk,
                  nominalDenda: x.dendaAbsenTidakLengkap,
                });

                // Terlambat di atas 10 menit (punya flag berlaku)
                if (absens.terlambatDiatas10berlaku) {
                  x.list_denda.push({
                    namaDenda: "Terlambat >10 Menit",
                    jumlah: absens.terlambatDiatas10,
                    nominalDenda: absens.terlambatDiatas10Total,
                  });
                }

                // Terlambat >60 menit (punya flag berlaku)
                if (absens.terlambatDiatas60berlaku) {
                  x.list_denda.push({
                    namaDenda: "Terlambat >60 Menit",
                    jumlah: absens.terlambatDiatas60,
                    nominalDenda: absens.terlambatDiatas60Total,
                  });
                }

                x.list_potongan.push({ namaPotongan: "Cuti", jumlah: absens.jumlahCuti, nominalPotongan: x.potonganCuti });
                x.list_potongan.push({ namaPotongan: "Sakit", jumlah: absens.jumlahSakit, nominalPotongan: x.potonganSakit });
                x.list_potongan.push({ namaPotongan: "Alpha", jumlah: absens.jumlahAlfa, nominalPotongan: x.potonganAlpha });
                x.list_potongan.push({ namaPotongan: "Ijin", jumlah: absens.jumlahIjin, nominalPotongan: x.potonganIjin });
                x.list_potongan.push({ namaPotongan: "Day Off", jumlah: absens.totalDayOff, nominalPotongan: x.potonganDayOff });
              }

              // === TUNJANGAN TETAP ===
              if (x.tunjangan) {
                x.tunjangan.forEach((ele) => {
                  x.totalTunjangan += Number(ele.nominalTunjangan);
                });
              }

              // === INSENTIF (Tunjangan tidak tetap × total jadwal) ===
              if (x.tunjanganTidakTetap && absens) {
                x.tunjanganTidakTetap.forEach((ele) => {
                  ele.insentif = ele.nominalTunjanganTidaktetap * absens.totalJadwal;
                  ele.jumlah = absens.totalJadwal;
                  x.list_insentif.push(ele);
                  x.totalInsentif += Number(ele.insentif);
                });
              }

              // === POTONGAN TAMBAHAN ===
              if (x.potongan) {
                x.potongan.forEach((ele) => {
                  x.list_potongan.push(ele);
                });
              }

              // === ASURANSI (non BPJS) ===
              if (x.asuransi) {
                x.asuransi.forEach((ele) => {
                  x.list_asuransi.push({
                    namaAsuransi: ele.namaAsuransi,
                    potonganAsuransi: ele.potonganAsuransi,
                  });
                  x.totalAsuransi += Number(ele.potonganAsuransi);
                });
              }

              // === ASURANSI BPJS ===
              if (x.bpjsKetenagaKerjaan) {
                x.list_asuransi.push({
                  namaAsuransi: "BPJS Ketenagakerjaan",
                  potonganAsuransi: x.bpjsKetenagaKerjaan,
                });
                x.totalAsuransi += Number(x.bpjsKetenagaKerjaan);
              }

              if (x.bpjsKesehatan) {
                x.list_asuransi.push({
                  namaAsuransi: "BPJS Kesehatan",
                  potonganAsuransi: x.bpjsKesehatan,
                });
                x.totalAsuransi += Number(x.bpjsKesehatan);
              }

              // === TOTAL DENDA ===
              x.list_denda.forEach((d) => {
                x.totalDenda += Number(d.nominalDenda);
              });

              // === TOTAL POTONGAN ===
              x.list_potongan.forEach((p) => {
                x.totalPotongan += Number(p.nominalPotongan);
              });

              // === GAJI PRORET ===
              x.gaji = Number(x.proret);

              // === TOTAL THP (mengikuti totalTHP()) ===
              x.takeHomePay = Math.floor(x.gaji + x.totalInsentif + x.totalNominalLembur + x.totalTunjangan + x.totalKomisi - x.totalPotongan - x.totalAsuransi - x.totalDenda);

              // === RETURN DATA UNTUK TABLE ===
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.dataKaryawan,
                namaMitra: x.namaMitra || " - ",
                namaGaji: vm.toNumeric(x.gaji, "idr"),
                namaTotalKomisi: vm.toNumeric(x.totalKomisi, "idr"),
                namaTotalAsuransi: vm.toNumeric(x.totalAsuransi, "idr"),
                namaTotalTunjangan: vm.toNumeric(x.totalTunjangan, "idr"),
                namaTotalInsentif: vm.toNumeric(x.totalInsentif, "idr"),
                namaTotalLembur: vm.toNumeric(x.totalNominalLembur, "idr"),
                namaTotalPotongan: vm.toNumeric(x.totalPotongan, "idr"),
                namaTotalDenda: vm.toNumeric(x.totalDenda, "idr"),
                namaTakeHomePay: vm.toNumeric(x.takeHomePay, "idr"),
              };
            })
          : [];
      vm.totalRows = parseInt(listLaporanGaji.data.count);
      vm.loading = false;
    },
    async getPeriodeGaji() {
      let vm = this;
      let listPeriodeGaji = await vm.$axios.post("periodeGajiMitra/list");
      // console.log('listPeriodeGaji : ', listPeriodeGaji)
      vm.listPeriodeGaji =
        listPeriodeGaji.data.status == 200
          ? listPeriodeGaji.data.data.map((x) => {
              x.namaTanggalGajian = x.tanggalGajian == -1 ? "akhir bulan" : "Tanggal " + x.tanggalGajian;
              x.namaTanggalAwal = x.tanggalAwal == -1 ? "akhir bulan" : x.tanggalAwal;
              x.namaTanggalAkhir = x.tanggalAkhir == -1 ? "akhir bulan" : x.tanggalAkhir;
              return {
                ...x,
                id: x.periodeGajiMitraId,
                namaPeriode: `Gajian ${x.namaTanggalGajian} (Kerja ${x.namaTanggalAwal} - ${x.namaTanggalAkhir})${x.isBpjs ? ", BPJS" : ""}`,
              };
            })
          : [];
    },
    // async getCabang() {
    //   let vm = this;
    //   let listCabang = await vm.$axios.post("cabang/list");
    //   vm.listCabang = listCabang.data.status == 200 ? listCabang.data.data : [];
    // },
    reset() {
      const vm = this;
      const month = vm.$moment().format("MM");
      const year = vm.$moment().format("YYYY");
      vm.filter.bulanTahun = new Date(vm.$moment(`01-${month}-${year}`, "DD-MM-YYYY"));
      vm.filter.periode = vm.listPeriodeGaji[0];
      vm.filter.cabang = vm.$store.state.cabang_aktif;
      this.hitungTanggal();
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
    toNumeric(number, type) {
      let data = {};
      if (type == "no-idr") {
        return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(number).slice(3); //10.000,00
      } else {
        if (type == "idr") data = { style: "currency", currency: "IDR" }; //Rp 10.000,00
        return new Intl.NumberFormat("id-ID", data).format(number); //10.000
      }
    },
  },
};
</script>
